// extracted by mini-css-extract-plugin
module.exports = {"button":"Pagination-module--button--1Vt0p","current":"Pagination-module--current--1rZbU"};